(ns frontend.test.select.event
  (:require [clojure.string :as string]
            [common.util :as cu]
            [frontend.test.select.model :as model]
            [re-frame.core :as rf]))

(rf/reg-event-fx
 ::query-async-select
 (fn [{db :db} [_ query callback-js]]
   (->> model/sample-options
        (filter (fn [o]
                  (or (cu/blank-value? query)
                      (string/starts-with? (:label o) query))))
        (take 200)
        (callback-js))))

(rf/reg-event-fx
 ::set-single-select-value
 (fn [{db :db} [_ value]]
   (model/set-single-value db value)))

(rf/reg-event-fx
 ::set-multi-select-value
 (fn [{db :db} [_ value]]
   (model/set-multi-value db value)))

(rf/reg-event-fx
 ::set-async-value
 (fn [{db :db} [_ value]]
   (model/set-async-value db value)))

(rf/reg-event-fx
 ::set-async-multi-value
 (fn [{db :db} [_ value]]
   (model/set-async-multi-value db value)))
